import { useQuery } from 'react-query';
import {
  authenticateUserApi,
  getAuthApiRequestParams,
} from '../services/AuthService';
import { getCommonApiWithToken } from './commonApi';
import { API_ROUTES } from '../constant';

export const useAuthenticateUserApi = (
  phone: string,
  action: string,
  language: string,
  newauth: boolean,
  otp?: string,
  partnerId?: string,
  screenName?: string,
  tokenForLoginSkip?: string,
  isReferralSuperstar?: boolean
) => {
  const requestParams = getAuthApiRequestParams(
    phone,    
    action,   
    language, 
    newauth,  
    otp,      
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    partnerId,
    screenName,
    tokenForLoginSkip,
    isReferralSuperstar=true
  );

  const { refetch, data, isLoading, error } = useQuery({
    queryKey: ['authenticateUserApi', requestParams],
    queryFn: async () => {
      try {
        return await authenticateUserApi(requestParams);
      } catch (err) {
        console.log(`Authentication failed: ${(err as any)?.message}`);
      }
    },
    staleTime: 0,
    enabled: false,
  });

   const userDetails = async ({token, t}:{token:string, t:any}) =>{
    try {
      await getCommonApiWithToken(API_ROUTES.REFERRAL_GET_USER_DETAILS, token).catch(function(error) {
        console.log(`${t('error404')} userDetails API Error ${error.response}`);
       });
       //console.log("userDetails",response);

    } catch (err) {
      console.log(`User details failed: ${(err as any)?.message}`);
    }
   }


  return {
    authResponse: data,
    isLoading,
    error,
    refetch,
    userDetails
  };
};
